import { useCallback } from "react";
import { clsx } from "clsx";

import "./ProgressSteps.css";

import type { SizeProp } from "../components";
import type { ReactNode, MouseEvent as ReactMouseEvent } from "react";

export interface ProgressStepsSelectEvent {
  value: number;
}

export interface ProgressStepsProps {
  currentStep?: number;
  size?: Extract<SizeProp, "sm" | "md" | "lg">;
  stepCount: number;
  variant?: "light" | "dark";
  onSelect?: (event: ProgressStepsSelectEvent) => void;
}

export function ProgressSteps({
  currentStep,
  size,
  stepCount,
  variant,
  onSelect,
}: ProgressStepsProps) {
  const renderSteps = useCallback(() => {
    const steps: ReactNode[] = [];

    for (let i = 0; i < stepCount; i++) {
      const position = i + 1;

      const indicatorProps = {
        className: "ProgressSteps__indicator",
        "aria-label": position.toString(),
      };

      steps.push(
        <li
          key={position}
          className={clsx("ProgressSteps__step", {
            "ProgressSteps__step--active": position === currentStep,
          })}
        >
          {onSelect ? (
            <button
              {...indicatorProps}
              onClick={(e: ReactMouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                onSelect?.({ value: position });
              }}
            />
          ) : (
            <div {...indicatorProps} />
          )}
        </li>,
      );
    }

    return steps;
  }, [currentStep, onSelect, stepCount]);

  return <ul className="ProgressSteps">{renderSteps()}</ul>;
}
